import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const convertBytesToMB = (bytes: number) => {
  return (bytes / (1024 * 1024)).toFixed(2);
};

export const formatDateString = (date_string: string) => {
  const inputDate = new Date(date_string);

  const day = inputDate.getDate().toString().padStart(2, '0');
  const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
  const year = inputDate.getFullYear().toString().slice(-2);

  return day + '/' + month + '/' + year;
};

export const SITE_REGION_CODES = ['au', 'nz', 'us', 'in'] as const;
export type SiteRegionCode = (typeof SITE_REGION_CODES)[number];

/** Regions served under unimig.com/{code} (excludes AU, which uses unimig.com.au). */
export const MULTI_REGION_SITE_CODES = ['nz', 'us', 'in'] as const;

export const COUNTRY_LOCALE_MAP: Record<string, string> = {
  au: 'en-AU',
  nz: 'en-NZ',
  us: 'en-US',
  in: 'en-IN',
};

export const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  au: 'AUD',
  nz: 'NZD',
  us: 'USD',
  in: 'INR',
};
